import React from 'react';
import { Zap, DollarSign, TrendingUp, BarChart3 } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      icon: Zap,
      title: "Instant Response",
      description: "24/7 availability • No missed calls • Zero wait times"
    },
    {
      icon: DollarSign,
      title: "Cut Costs 80%",
      description: "Save on staff • Cut monthly costs • Make more profit"
    },
    {
      icon: TrendingUp,
      title: "Scale Unlimited",
      description: "Handle 1000s of chats • Peak hour coverage • Never get overwhelmed"
    },
    {
      icon: BarChart3,
      title: "Smart Insights",
      description: "Customer analytics • Popular questions • Service improvements"
    }
  ];

  return (
    <section id="benefits" className="section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Why choose <span style={{color: '#1E40AF'}}>AI customer service</span>?
          </h2>
        </div>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div key={index} className="card">
                <div className="card-icon">
                  <IconComponent size={40} />
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;